import "firebase/compat/storage";
import firebase from "../firebase";

export default firebase.storage;
